var sw = sw || {};


// Submit Form
//-----------------------------------------------------------------
sw.submitForm = function() {
    var $form = $('#form-invitation');

    if (!$form.length) {
        return;
    }

    $form.submit(function(e) {
        e.preventDefault();

        $.ajax({
            url: $form.attr("action"),
            type: $form.attr("method"),
            data: $form.serialize(),
            success: function(response) {
                response = jQuery.parseJSON(response);

                if (response.status=="success") {
                    $form.find(".form__submit span").html(response.message);
                } else {
                    //alert(response.message);
                }
            }            
        });
    });

};





$(document).ready(function (){
    sw.submitForm();
});